import React from 'react'

function QuadnutStore() {
    return (
        <>

            <section>
                <div className="row">
                    <div className="col-xl-12 p-4">
                        QuadnutStore
                    </div>
                </div>
            </section>








        </>
    )
}

export default QuadnutStore